import { Component } from '@angular/core';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GrupoService } from '../../../../services/grupo/grupo.service';
import { SubGrupoDTO, SubGrupoCreateDTO, SubGrupoFormDTO } from '../../../../models/subgrupo.model';

import { SubGrupoService } from '../../../../services/grupo/sub-grupo.service';
import { GrupoDTO } from '../../../../models/grupo.model';

@Component({
  selector: 'app-sub-grupo-edit',
  templateUrl: './sub-grupo-edit.component.html',
  styleUrl: './sub-grupo-edit.component.scss',
  providers: [ConfirmationService, MessageService],
})
export class SubGrupoEditComponent {
  checked = false;
  date2: Date | undefined;
  grupos: GrupoDTO[] = [];
  first3 = 0;
  rows3 = 5;
  totalRecords = 0;
  lastfield = '';
  lastSort = '';
  options = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 120, value: 120 },
  ];
  form: SubGrupoFormDTO = this.createEmptyForm();
  stateOptions: any[] = [
    { label: 'Ativo', value: true },
    { label: 'Inativo', value: false },
  ];

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private subgrupoService: SubGrupoService,
    private grupoService: GrupoService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.findGrupos();

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.subgrupoService.getById(`/subgrupo/${id}`).subscribe((response) => {
        this.form = {
          id: response.id,
          grupo_id: response.grupos?.map(g => g.id!).filter(id => id != null) ?? [],
          nome: response.nome,
        };
      });
    }
  }

  findGrupos(): Promise<void> {
    return new Promise((resolve) => {
      this.grupoService.get('/grupo?listarTodos=true').subscribe((response) => {
        this.grupos = response.content;
        resolve();
      });
    });
  }

  getEmpresaId(): number {
    return Number(sessionStorage.getItem('id'));
  }

  submit() {
    if (this.form.nome === '' || this.form.nome === null) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('subgrupo.mensagens.campo_nome_obrigatorio'),
      });
      return;
    }

    if (!this.form.grupo_id || this.form.grupo_id.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('subgrupo.mensagens.campo_grupo_obrigatorio'),
      });
      return;
    }

    const body: SubGrupoCreateDTO = {
      nome: this.form.nome!,
      grupo_id: this.form.grupo_id,
      empresaId: this.getEmpresaId()
    };

    this.subgrupoService.put(`/subgrupo/${this.form.id}`, body).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: this.translate.instant('common.sucesso'), detail: this.translate.instant('subgrupo.mensagens.subgrupo_editado') });
        this.router.navigate(['/subgrupo']);
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: this.translate.instant('common.erro'), detail: this.translate.instant('subgrupo.mensagens.falha_editar_subgrupo') });
      },
    });
  }

  createEmptyForm(): SubGrupoFormDTO {
    return {
      nome: '',
      grupo_id: [],
    };
  }
}
